import $ from 'jquery';
import 'slick-carousel';
import Viewport from './Viewport';
import Redirect from './Redirect';

const defaults = {
  speed: 500,
  dots: true,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

/**
 * Home Timeline Slider Constructor
 */
function Slider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.$gallery = this.build();
  this.addListeners();
  this.ready();
}

Slider.prototype = {
  build() {
    return $('.view-content', this.element).slick(this.settings);
  },
  addListeners() {
    if (Viewport.mobileState) {
      this.$element.find('.views-row').each((i, elem) => {
        if (!elem.redirect) {
          elem.redirect = new Redirect(elem);
        }
      });
    }
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Slider;
